<script>
	import GraphicHeader from './GraphicHeader.svelte';
	// import GraphicFooter from './GraphicFooter.svelte';
	export let header, footer;
</script>

<div class="graphic">
	<GraphicHeader {header} />
	<slot />
	<!-- <GraphicFooter {footer} /> -->
</div>
